import { Pipe, PipeTransform } from '@angular/core';

/**
 * Capitalizes the first letter only of the word or sentence.
 */
@Pipe({
    name: 'capitalizeFirstLetter',
    standalone: false
})
export class CapitalizeFirstLetterPipe implements PipeTransform {
  transform(word: string): string {
    if (!word?.length) return '';
    return word[0].toUpperCase() + word.slice(1);
  }
}
